export default Alpine.data('googleMapsAutocomplete', (livewireInstance, value, waitForSave) => {
    return {
        search: '',
        autocomplete: null,
        updateValue(value) {
            this.autocomplete.Dg.value = value.detail;
        },
        async init() {
            await google.maps.importLibrary("places");

            const placeAutocomplete = new google.maps.places.PlaceAutocompleteElement({
                id: 'autocomplete-input',
            });

            this.autocomplete = placeAutocomplete;

            // Sets the value on the input
            if (value && value !== 'None') {
                placeAutocomplete.Dg.value = value
            }

            this.$refs.autocomplete.appendChild(placeAutocomplete);

            const selectedPlaceTitle = document.createElement('p');
            selectedPlaceTitle.textContent = '';
            this.$refs.autocomplete.appendChild(selectedPlaceTitle);
            const selectedPlaceInfo = document.createElement('pre');
            selectedPlaceInfo.textContent = '';
            this.$refs.autocomplete.appendChild(selectedPlaceInfo);

            placeAutocomplete.addEventListener('gmp-select', async ({ placePrediction }) => {
                console.log(placePrediction);
                const place = placePrediction.toPlace();
                await place.fetchFields({ fields: ['postalAddress', 'formattedAddress', 'location'] });

                livewireInstance.updateAddress(place.id, place.postalAddress, place.formattedAddress, place.location.lat(), place.location.lng());
            });

            placeAutocomplete.addEventListener('blur', () => {
                const currentValue = placeAutocomplete.Dg.value;

                // If the input is empty or cleared, clear the Livewire location data
                if (!currentValue || currentValue.trim() === '') {
                    livewireInstance.clearAddress();
                }
            });
        },
    }
});
